import { useState, useEffect } from "react";

export const SUPPORTS_HOVER = "(hover: hover)";

export const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(() => {
		if (window.matchMedia) {
			return window.matchMedia(query).matches;
		}
		return false;
	});

	useEffect(() => {
		if (!window.matchMedia) {
			return;
		}

		const mediaQueryList = window.matchMedia(query);

		const listener = (event) => {
			setMatches(event.matches);
		};

		mediaQueryList.addEventListener("change", listener);

		setMatches(mediaQueryList.matches);

		return () => {
			mediaQueryList.removeEventListener("change", listener);
		};
	}, [query, window.matchMedia]);

	return matches;
};
